export default {
  field: {
    label: 'Btw-categorie',
    placeholder: 'Geen btw-categorie',
    unlinked_hint:
      'Zonder categorie gebruikt een product de btw-categorie van zijn menucategorie of het standaardtarief van het restaurant.',
    default_hint: 'Zonder categorie opgeslagen, krijgt het de standaard btw-categorie van het menu.',
  },
  empty: {
    hint: 'Nog geen btw-categorieën — voeg er hieronder een toe.',
    read_only_hint: 'Er zijn nog geen belastingcategorieën ingesteld.',
  },
  option: {
    varies_by_channel: '(verschilt per kanaal)',
  },
  load_error:
    'Btw-categorieën konden niet worden geladen — koppelen en ontkoppelen is uitgeschakeld tot dit is geladen.',
  create: {
    name_placeholder: 'Nieuwe categorienaam',
    rate_placeholder: 'Tarief %',
    button: 'Btw-categorie toevoegen',
  },
  toasts: {
    create_error: 'De btw-categorie kon niet worden aangemaakt.',
  },
};
